import React, { useState, useEffect } from 'react';
import MobileRafflePage from './MobileRafflePage';
import DesktopRafflePage from './DesktopRafflePage';

const RafflePage = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Detectar si es móvil por tamaño de pantalla y agente de usuario
    const checkMobile = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
      const isMobileDevice = mobileRegex.test(userAgent);
      const isSmallScreen = window.innerWidth <= 768;
      
      setIsMobile(isMobileDevice || isSmallScreen);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Renderizar la versión apropiada
  return isMobile ? <MobileRafflePage /> : <DesktopRafflePage />;
};

export default RafflePage;